import { OrderType } from '@fd/common/biz/order';

declare global {
  interface Window {
    dataLayer: object[];
  }
}

/**
 * 1. Событие регистрации
 */
export const analyticsOnRegistration = async (email: string) => {
  window.dataLayer = window.dataLayer || [];
  // При успешной регистрации добавьте следующий код в dataLayer:
  window.dataLayer.push({
    event: 'registration',
    user_id: email, // Уникальный ID пользователя, который связывает все события в Amplitude
    email: email, // Зашифрованный email пользователя (например, в MD5 или SHA-256)
  });
};

/**
 * 
 * Событие покупки
  Когда пользователь совершает покупку, добавьте в dataLayer данные о транзакции.Код должен включать следующие параметры:
  
  Тип покупки: одноразовая, подписка или повторная одноразовая покупка.
  Длительность подписки: ежемесячная или годовая(передаётся только для подписок).
  Тип прокси и количество купленных гигабайт.
  
  Пример кода для события покупки:

 * @param email 
 * @param user_id 
 */
export const analyticsOnPurchase = async (email: string, order: OrderType) => {
  /**
   * Описание параметров
    event: Название события для GTM.Для регистрации — registration, для покупки — purchase.
    user_id: Уникальный идентификатор пользователя.Используется для отслеживания действий одного пользователя.
    email: Зашифрованный email пользователя.Амплитуда не требует email в незашифрованном виде.
    purchase_type: Тип покупки, возможные значения:
    one_time — одноразовая покупка;
    subscription — подписка;
    one_time_repeat — повторная одноразовая покупка.
    subscription_duration: Продолжительность подписки для события подписки, возможные значения:
    monthly — ежемесячная подписка;
    annual — годовая подписка.
    transaction_id: Уникальный идентификатор транзакции, необходим для различения покупок.
    amount: Сумма покупки.
    currency: Валюта, например, USD.
    proxy_type: Тип прокси, который выбрал пользователь(например, residential или datacenter).
    gigabytes: Количество купленных гигабайт.
   */

  const purchase_type = order.recurrent ? 'subscription' : 'one_time'; // Тип покупки: 'one_time', 'subscription', или 'one_time_repeat'
  const transaction_id = order.id;
  const amount = order.amount;

  window.dataLayer = window.dataLayer || [];
  const event = {
    event: 'purchase',
    user_id: email, // email
    email: email, // email
    purchase_type, // Тип покупки: 'one_time', 'subscription', или 'one_time_repeat'
    transaction_id, // Уникальный ID транзакции
    amount, // Сумма покупки
    currency: 'USD', // Валюта
    residentialGb: order.residentialGb,
    mobileGb: order.mobileGb,
    datacenterGb: order.datacenterGb,
  };
  console.log('purchase', event);
  window.dataLayer.push(event);
};
